import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export function EmptyStateActionButtons({
  actionUrl,
  actionLabel,
  settingsPath,
  variant,
  compact,
}) {
  if (!actionUrl && !settingsPath) return null;
  return (
    <div className={cn("flex flex-col items-center gap-2 w-full", compact ? "mt-4" : "mt-5")}>
      {actionUrl ? (
        <a href={actionUrl} target="_blank" rel="noopener noreferrer" className="w-full max-w-[240px]">
          <Button
            size="sm"
            className={cn(
              "w-full",
              variant === "action_required" && "bg-amber-600 hover:bg-amber-700 text-white",
            )}
            variant={variant === "action_required" ? "default" : "outline"}
          >
            <ExternalLink size={13} className="mr-1.5 shrink-0" />
            {actionLabel || "Open setup"}
          </Button>
        </a>
      ) : null}
      {settingsPath ? (
        <Link to={settingsPath} className="w-full max-w-[240px]">
          <Button size="sm" variant="outline" className="w-full">
            Open connections
          </Button>
        </Link>
      ) : null}
    </div>
  );
}

EmptyStateActionButtons.propTypes = {
  actionUrl: PropTypes.string,
  actionLabel: PropTypes.string,
  settingsPath: PropTypes.string,
  variant: PropTypes.oneOf(["action_required", "info", "default"]),
  compact: PropTypes.bool,
};

function resolveEmptyIcon(variant, ChannelIcon, DefaultIcon) {
  if (variant === "default" && ChannelIcon) return ChannelIcon;
  return DefaultIcon;
}

export function emptyStateTextClasses(compact, type) {
  if (type === "title") {
    return compact ? "text-[12.5px] max-w-[260px]" : "text-[15px] max-w-md";
  }
  return compact ? "text-[11.5px] max-w-[260px]" : "text-[13px] max-w-md";
}

export { resolveEmptyIcon };
